import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import React, { useCallback, useState } from 'react';
import { Popover } from '@mantine/core';

import { CommonPopover } from '@shipstation/client-common/components/common-popover';

import { Button } from 'ui-components/components/button';
import { useMaxZ } from 'ui-components/hooks/services/use-max-z';

import sharedStyle from '../style.module.css';
import { EditLotPopoverBody } from './edit-lot-popover-body';

/**
 * @param {object} props
 * @param {() => void} props.onReloadLocations
 * @param {string} props.productId
 * @param {boolean} props.isPopoverOpen
 * @param {() => void} props.onClose
 * @param {string} [props.lot]
 * @param {string} props.lotUuid
 * @param {string} [props.expirationDate]
 * @param {JSX.Element} [props.target] Element to anchor to instead of the default icon button
 * @returns {JSX.Element}
 */

export const EditLotPopover = ({
  onReloadLocations,
  productId,
  isPopoverOpen,
  onClose,
  lot = '',
  lotUuid,
  expirationDate = '',
  target,
}) => {
  const zIndex = useMaxZ();
  const [isOpen, setIsOpen] = useState(isPopoverOpen);
  const onOpenPopover = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, [setIsOpen]);
  const onOuterAction = useCallback(() => {
    setIsOpen(false);
    onClose();
  }, [setIsOpen, onClose]);
  const onOpenChange = useCallback((nextOpen) => (nextOpen ? undefined : onOuterAction()), [onOuterAction]);

  const editLotPopoverProps = {
    expirationDate,
    lot,
    lotUuid,
    onOuterAction,
    onReloadLocations,
    productId,
    setIsOpen,
  };

  return (
    <CommonPopover
      classNames={{ dropdown: sharedStyle['inventory-popover-dropdown'], arrow: sharedStyle['inventory-popover-arrow'] }}
      onChange={onOpenChange}
      opened={isOpen}
      position='bottom'
      returnFocus
      trapFocus
      withArrow
      zIndex={zIndex}
    >
      <Popover.Target>
        {target ?? (
          <Button className={sharedStyle['adjust-icon']} onClick={onOpenPopover} theme='link'>
            <FontAwesomeIcon className={sharedStyle.icon} icon={faPlus} />
          </Button>
        )}
      </Popover.Target>
      <Popover.Dropdown>
        <EditLotPopoverBody {...editLotPopoverProps} />
      </Popover.Dropdown>
    </CommonPopover>
  );
};
